import styled from 'styled-components';
import { step } from 'tokens';

export const Control = styled.div`
	display: flex;
	align-items: center;
	gap: 1px;
	width: fit-content;
`;

export const Button = styled.button`
	padding: 4px 8px;

	border: none;
	border-radius: 0;
	&:first-child {
		border-top-left-radius: ${step}px;
		border-bottom-left-radius: ${step}px;
	}
	&:last-child {
		border-top-right-radius: ${step}px;
		border-bottom-right-radius: ${step}px;
	}

	background: ${({ theme }) => theme.gray[100]};
	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}

	> svg {
		// when icons are used, don’t show space underneath.
		display: block;
	}
`;

export const Icon = styled.div`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
`;
